import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getConsultantIndustries } from '@/actions/consultant-industries/getConsultantIndustries';
import { ConsultantIndustries } from '@/types/consultant.type';
import { ApiResponse } from '@/types/response.type';

export interface UseGetConsultantIndustriesReturn {
  result: ApiResponse<ConsultantIndustries> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetConsultantIndustries =
  (): UseGetConsultantIndustriesReturn => {
    const query: UseQueryResult<
      ApiResponse<ConsultantIndustries> | undefined,
      Error
    > = useQuery({
      queryKey: ['consultant-industries'],
      queryFn: getConsultantIndustries,
    });

    return {
      result: query.data,
      error: query.error,
      isError: query.isError,
      isSuccess: query.isSuccess,
      isLoading: query.isPending,
      isRefetching: query.isRefetching,
    };
  };
